import { defineStore } from "pinia";

const CHECK_INTERVAL_MS = 30000; // Comprobar cada 30s

const getDefaultState = () => ({
    lastActivity: Date.now(),
    sessionExpired: false,
    idleTime: 10 * 60 * 1000,
    _checkInterval: null,
});

export const useIdleStore = defineStore("idle", {
    state: getDefaultState,
    persist: {
        pick: ['lastActivity', 'idleTime'],
    },
    actions: {

        touchActivity() {
            if (this.sessionExpired) return;
            this.lastActivity = Date.now();
        },

        startWatching() {
            this.sessionExpired = false;
            this.lastActivity = Date.now();
            this.stopWatching();

            this._checkInterval = setInterval(() => {
                if (this.sessionExpired) return;
                if (Date.now() - this.lastActivity >= this.idleTime) {
                    this.sessionExpired = true;
                }
            }, CHECK_INTERVAL_MS);
        },

        stopWatching() {
            if (this._checkInterval) {
                clearInterval(this._checkInterval);
                this._checkInterval = null;
            }
        },

        resetIdleSession() {
            this.sessionExpired = false;
            this.lastActivity = Date.now();
        },

        setIdleTime(time) {
            this.idleTime = time;
            this.sessionExpired = false;
            this.lastActivity = Date.now();
        },

        checkIdleNow() {
            if (this.sessionExpired) return;
            if (Date.now() - this.lastActivity >= this.idleTime) {
                this.sessionExpired = true;
            }
        },

    },
});
